export class ShopTarifierungRequestEvents {
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_VWG = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_VWG';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_VWG_V2 = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_VWG_V2';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_VHV = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_VHV';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_VHV_V2 = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_VHV_V2';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_PH = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_PH';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_RS = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_RS';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_RS_VM = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_RS_VM';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_HUND = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_HUND';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_PFERD = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_PFERD';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV_V2 = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV_V2';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_UNF = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_UNF';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_JHP = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_JHP';
  static readonly PREISE_SHOP_REQUESTED_SUCCESSFUL_GEGE = 'PREISE_SHOP_REQUESTED_SUCCESSFUL_GEGE';

  static readonly PREISE_SHOP_REQUESTED_FAILED = 'PREISE_SHOP_REQUESTED_FAILED';
}
